import { FC } from "react";

import { EventBusTopic } from "@moodys/mdc-frontend.utils.event-bus";
import LinkedIn from "@mui/icons-material/LinkedIn";
import Twitter from "@mui/icons-material/Twitter";
import YouTube from "@mui/icons-material/YouTube";
import { IconButton } from "@mui/material";

import { analytics } from "@moodys/federated";
import { useFooterTranslation } from "components/Footer/i18n";
import { useEventBus } from "hooks/useEventBus";
import { getPageLanguage } from "utils/language";

import { generateFooterAnalyticsProp } from "../../../../utils/generateAnalyticsTag";
import { socialsModels } from "../../model";

import { socialLinksStyles as styles } from "./SocialLinks.styles";

const icons = {
  twitter: <Twitter />,
  youtube: <YouTube />,
  linkedin: <LinkedIn />,
};

export const SocialLinks: FC = () => {
  const { translate } = useFooterTranslation();
  const [languageNodes] = useEventBus(
    EventBusTopic.Shell.AemMenu.LanguageNodes
  );

  return (
    <div css={styles.container}>
      {socialsModels.map((node) => (
        <IconButton
          key={node.titleKey}
          aria-label={translate(node.titleKey)}
          css={styles.icon}
          component="a"
          href={node.href[getPageLanguage(languageNodes)] || node.href.en}
          target="_blank"
          rel="noreferrer"
          size="small"
          className="social-link"
          {...generateFooterAnalyticsProp({
            name: translate(node.titleKey).split(" ").pop(),
            type: analytics.LinkType.BUTTON,
          })}
        >
          {icons[node.titleKey as keyof typeof icons]}
        </IconButton>
      ))}
    </div>
  );
};
